import * as svg from "../../../assets/dashboard-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const DashboardIcon = iconBuilder(svg, "DashboardIcon", "0 0 16 16");
